<template>
	<transition name="menuani">
		<div class="menublock"  @blur='leaveMenu' ref='menublock'>

			<div v-if='pageon==0' style="width: 100%">

				<div class="blocksSection" v-for='(menu,menui) in menuData.menu_block' :key='menui'>
					<div class="ztitle" @click='menu.show = !menu.show'>
						<svg-icon icon-class='down' :style='menu.show ? "":"transform: rotate(-90deg)"'/>
						{{menu.title}}
					</div>
					<transition name="menuani" >
						<draggable v-show='menu.show' @end='dragend' @start='dragstart' v-model='menu.list' class="btns" :options='menuData.menuOption' >
							<transition-group>
								<section v-for='(item,index) in menu.list' :key='menui+index' @click='MenuClick(item)' :data-item='item'>
									<svg-icon class='ico' :icon-class='item.ico' />
									<span>{{item.tagName}}</span>
								</section>
							</transition-group>
						</draggable>
					</transition>

				</div>

			</div>
			<div v-if='pageon==1' class="widget">
				<div class="pagelist">
					<div class="list">
						<el-checkbox v-model='menuData.widget[0].check' :label='menuData.widget[0].tagName' type='primary'></el-checkbox>
					</div>
				</div>
			</div>
			<div v-if='pageon==2' class="pages">
				<div class="colorful">
					<div class="li" @click='appConfig.style=item' :class='appConfig.style==item? "on":""' v-for='(item,index) in ajaxData.colorful' :style='"background:"+item'></div>
					<div class="li">
						<img style="width: 100%;height: 100%;" src="@/assets/colorful.png" alt="">
						<el-color-picker style='position: absolute;left: 0;top: 0;opacity: 0' v-model="appConfig.style" show-alpha></el-color-picker>
					</div>
				</div>
				<div class="pagelist">
<!-- 					<div class="list" :class='menuData.appPageon==index?"on":""'  @click='pageClick(item,index)' v-for='(item,index) in defaultConfig.appPage'>
						<p  @dblclick='editTitle(item,"menu_"+index)'>
							<el-input size='mini' :id="'menu_'+index" placeholder='输入页面标题' v-model='item.title' @keyup.enter.native='item.edit=false' @blur='item.edit=false' v-if='item.edit' />
							<span v-else>{{item.title}}</span>
						</p>
						<div class="del" :style='item.candel? "":"color:#ccc"' @click.stop='delPage(item,index)'>
							<svg-icon icon-class='del'/>
						</div>
					</div> -->
					<div class="list" :class='menuData.appPageon==index?"on":""'  @click='pageClick(item,index)' v-for='(item,index) in menuData.appPage'>
						<p  @dblclick='editTitle(item,"menu_"+index)'>
							<el-input size='mini' :id="'menu_'+index" placeholder='输入页面标题' v-model='item.title' @keyup.enter.native='item.edit=false' @blur='item.edit=false' v-if='item.edit' />
							<span v-else>{{item.title}}</span>
						</p>
						<div class="del" :style='item.candel? "":"color:#ccc"' @click.stop='delPage(item,index)'>
							<svg-icon icon-class='del'/>
						</div>
					</div>
					<div class="list add" @click='addpage'>
						<svg-icon icon-class='add'/>
						<span>添加页面</span>
					</div>
				</div>
			</div>                                                                                                                                                                                                                                                                                                                                 
		</div>
	</transition>    
</template>

<style scoped="">
.menublock{
}
</style>

<script>
	import draggable from 'vuedraggable'
	import Sortable  from 'sortablejs'
	import defaultConfig from "@/components/defaultConfig"
	var p,lb,rb,pb,pagei=1;
	export default{
		components:{
			draggable,
			Sortable
		},
		watch:{
			'$store.state.pageon':{
				handler(val,oldVal){
					this.pageon = this.$store.state.pageon;
				}
			},
		},
		props:{
			menuData:{
				type:Object
			},
			appConfig:{
				type:Object
			},
			ajaxData:{
				type:Object
			}
		},
		data(){
			return{
				defaultConfig:defaultConfig(),
				pageon:this.$store.state.pageon,
			}
		},
		methods:{
			MenuClick(item){
				if(p.appConfig.appPage[p.appConfig.appPageon].body[0] && p.appConfig.appPage[p.appConfig.appPageon].body[0].systemPage){
					return 
				}
				if(item.tagName!="文本" && item.tagName!="图片" && item.tagName!="按钮"){
					var body = JSON.parse(JSON.stringify(p.phoneData.body))
					body.push(item)
					this.$set(p.appConfig.appPage[p.appConfig.appPageon],'body',body)
					this.$set(p.phoneData,"body",p.appConfig.appPage[p.appConfig.appPageon].body)
					pb.pageToEnd()
				}
				else{
					this.$message({
						message:'请将此组件拖拽至自由容器',
						type:'info'
					});
				}
			},
			editTitle(item,id){
				this.$set(item,'edit',true);
				setTimeout(()=>{
					var sc = document.getElementById(id);
					console.log(sc)
					sc.focus()
				})
			},
			dragstart(e){
				console.log('设置dragZindex')
				this.$set(pb,'dragZindex',10050);
				this.$emit('menudeagStart',e)
			},
			dragend(e){
				this.$set(pb,'dragZindex',0);
				this.$emit('menudeagEnd',e)
			},
			leaveMenu(){
			},
			pageClick(item,index){
				this.$router.push({path:'/blocks/index/'+index})
			},
			delPage(item,index){
				if(!item.candel){

					this.$message.error('此页面为系统页面，无法删除。')
					return false;
				}
				else if(this.$route.params.page == index){
					this.$message("请先离开此页面在执行删除操作")
					return
				}
				this.$confirm('页面删除后将无法恢复, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					p.appConfig.appPage.splice(index,1);
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				}).catch(() => {
				});
			},
			addpage(){
				var pagename = Date.parse(new Date())+(Math.random()*10);
				console.log("name",pagename)
				p.appConfig.appPage.push({title:'自定义页面',type:'page',url:"slef://"+pagename,body:[],candel:true})
			},
		},
		mounted(){
			p = this.$parent;
			pb = this.$parent.$refs.phoneBlock;
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/menuBolck/menuBolck.vue